import * as React from "react";
import { createContext, PropsWithChildren, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "~/Services/Request";
import { Options } from "~/Types/Options";

const OptionsContext = createContext<Options>({} as any);

export const useOptionsContext = () => {
    return useContext(OptionsContext);
};

export const OptionsProvider = (props: PropsWithChildren) => {
    const { data } = useQuery({
        queryKey: ["admin/options"],
        queryFn: () => {
            return get<Options>("/admin/options");
        },
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    });

    if (!data) {
        return null;
    }

    return <OptionsContext.Provider value={data}>{props.children}</OptionsContext.Provider>;
};
